module.exports = __webpack_public_path__ + "static/media/pablo.cd33a407.png";